/* src/app/shared/components/tabs-navigation/tabs-navigation.component.scss */
.tabs-navigation {
  border-bottom: 2px solid var(--cds-border);
}
.tab-button {
  background: none;
  border: none;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 500;
  color: var(--cds-text-light);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.tab-button.active {
  color: var(--cds-primary-600);
  font-weight: 600;
}
.tab-button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--cds-primary-600);
}
/*# sourceMappingURL=tabs-navigation.component.css.map */
